<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="mt-6 bg-white rounded shadow-lg p-6">
        <h3 class="font-semibold text-base text-blueGray-700">领奖风控白名单</h3>
        <p class="mt-2 mb-6 text-sm text-gray-600">按 unionid 全平台生效；仅跳过领奖时的微信账号风险等级校验。</p>

        <el-form v-if="canEditPage" :model="form" label-width="90px" class="mb-6" @submit.prevent="addUser">
          <el-form-item label="unionid">
            <el-input v-model="form.unionid" placeholder="输入用户 unionid" style="max-width: 420px" />
          </el-form-item>
          <el-form-item label="添加原因">
            <el-input v-model="form.reason" maxlength="200" show-word-limit placeholder="填写原因，便于追溯" style="max-width: 420px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="saving" @click="addUser">添加到白名单</el-button>
          </el-form-item>
        </el-form>

        <el-form :inline="true" @submit.prevent="loadList(1)">
          <el-form-item label="查询 unionid">
            <el-input v-model="searchUnionid" clearable placeholder="输入完整 unionid" />
          </el-form-item>
          <el-form-item><el-button @click="loadList(1)">查询</el-button></el-form-item>
        </el-form>

        <div class="overflow-x-auto">
          <el-table v-loading="loading" :data="rows" border stripe style="width: 100%; min-width: 720px">
            <el-table-column prop="_id" label="unionid" min-width="220" />
            <el-table-column prop="reason" label="添加原因" min-width="170" />
            <el-table-column prop="operator" label="最近操作人" min-width="160" />
            <el-table-column label="更新时间" width="175">
              <template #default="scope">{{ formatTime(scope.row.mtime) }}</template>
            </el-table-column>
            <el-table-column v-if="canEditPage" label="操作" width="85">
              <template #default="scope">
                <el-button type="danger" link :disabled="saving" @click="removeUser(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="mt-4 flex justify-end"
          background
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="20"
          :total="total"
          @current-change="loadList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { luckdrawApi } from "@/api/luckdraw.js";
import { getUserInfo } from "@/utils/auth.js";
import { canEdit, MENU_PERMISSION_KEYS } from "@/utils/rbac.js";

export default {
  name: "AwardRiskWhitelist",
  data() {
    return {
      form: { unionid: "", reason: "" },
      searchUnionid: "",
      rows: [],
      page: 1,
      total: 0,
      loading: false,
      saving: false,
    };
  },
  computed: {
    canEditPage() {
      return canEdit(getUserInfo(), MENU_PERMISSION_KEYS.CUSTOMERS_AWARD_RISK_WHITELIST);
    },
  },
  mounted() {
    this.loadList(1);
  },
  methods: {
    async loadList(page = 1) {
      this.loading = true;
      try {
        const result = await luckdrawApi.listAwardRiskWhitelist({
          unionid: this.searchUnionid.trim(), page, page_size: 20,
        });
        if (result.sta !== 0) throw new Error(result.msg || "获取白名单失败");
        this.rows = result.data.list || [];
        this.total = result.data.count || 0;
        this.page = page;
      } catch (error) {
        this.$message.error(error.message || "获取白名单失败");
      } finally {
        this.loading = false;
      }
    },
    async addUser() {
      const unionid = this.form.unionid.trim();
      const reason = this.form.reason.trim();
      if (!unionid || !reason) {
        this.$message.error("请填写 unionid 和添加原因");
        return;
      }
      this.saving = true;
      try {
        const result = await luckdrawApi.addAwardRiskWhitelist({ unionid, reason });
        if (result.sta !== 0) throw new Error(result.msg || "添加失败");
        this.$message.success("已加入白名单");
        this.form = { unionid: "", reason: "" };
        await this.loadList(1);
      } catch (error) {
        this.$message.error(error.message || "添加失败");
      } finally {
        this.saving = false;
      }
    },
    async removeUser(row) {
      try {
        await this.$confirm(`确认将 ${row._id} 移出领奖风控白名单？`, "操作确认", { type: "warning" });
      } catch (_) {
        return;
      }
      this.saving = true;
      try {
        const result = await luckdrawApi.removeAwardRiskWhitelist({ unionid: row._id });
        if (result.sta !== 0) throw new Error(result.msg || "移除失败");
        this.$message.success("已移出白名单");
        await this.loadList(this.page);
      } catch (error) {
        this.$message.error(error.message || "移除失败");
      } finally {
        this.saving = false;
      }
    },
    formatTime(timestamp) {
      return timestamp ? new Date(timestamp * 1000).toLocaleString("zh-CN") : "-";
    },
  },
};
</script>
